import React from 'react';
import { motion, useAnimation } from 'framer-motion';
import TintedIcon from './TintedIcon';

interface DesktopIconProps {
  icon: string;
  label: string;
  onClick: () => void;
  isDarkMode?: boolean;
}

const DesktopIcon: React.FC<DesktopIconProps> = ({ icon, label, onClick, isDarkMode = false }) => {
  const isImageIcon = icon.startsWith('/') || icon.includes('.');
  const shakeControls = useAnimation();

  const handleClick = async () => {
    await shakeControls.start({
      rotate: [0, -12, 12, -10, 10, -6, 6, -3, 3, 0],
      transition: { duration: 0.5, ease: 'easeInOut' },
    });
    onClick();
  };

  return (
    <motion.button
      onClick={handleClick}
      className="flex flex-col items-center gap-2 sm:gap-3 p-2 sm:p-3 rounded-lg bg-transparent border-0 outline-none group relative flex-shrink-0 active:scale-95"
    >
      <motion.div
        animate={shakeControls}
        className="w-14 h-14 sm:w-16 sm:h-16 md:w-20 md:h-20 flex items-center justify-center"
      >
        {isImageIcon ? (
          <div className="h-full w-full drop-shadow-lg">
            <TintedIcon
              src={icon}
              alt={label}
              isDarkMode={isDarkMode}
              className="h-full w-full"
            />
          </div>
        ) : (
          <span className="text-5xl sm:text-6xl drop-shadow-lg">{icon}</span>
        )}
      </motion.div>
      <span
        className="text-xs sm:text-sm md:text-base font-bold text-center transition-colors duration-200"
        style={{
          color: isDarkMode ? '#ffffff' : '#111111',
          textShadow: isDarkMode
            ? '0 2px 4px rgba(0,0,0,0.9)'
            : '0 1px 3px rgba(255,255,255,0.7)',
        }}
      >
        {label}
      </span>
    </motion.button>
  );
};

export default DesktopIcon;
